import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { UpdateClusterScoreSchema } from "schema"
import { z } from "zod"

type UpdateScoreData = z.infer<typeof UpdateClusterScoreSchema>

export const useUpdateClusterScoreMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: UpdateScoreData) => {
      const { data: response } = await axios.patch<{ data: { success: boolean } }>(
        "/backoffice/clusters/score",
        data,
      )
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["backofficeClusterKeys"],
      })
    },
  })
}
